import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkAuthStatus } from '../../services/authService';

const AuthNotification: React.FC = () => {
  const navigate = useNavigate();
  const [notification, setNotification] = useState<{
    show: boolean;
    message: string;
    isError: boolean;
  }>({
    show: false,
    message: '',
    isError: false
  });

  useEffect(() => {
    // Prüfe den Auth-Status beim ersten Laden
    checkAndUpdateStatus();

    // Setze einen Interval, um regelmäßig zu prüfen
    const intervalId = setInterval(checkAndUpdateStatus, 60000); // Alle 60 Sekunden prüfen

    // Event-Listener für Auth-Änderungen hinzufügen
    window.addEventListener('auth-change', checkAndUpdateStatus);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('auth-change', checkAndUpdateStatus);
    };
  }, []);

  const checkAndUpdateStatus = () => {
    const status = checkAuthStatus();

    // Wenn eine Neuanmeldung erforderlich ist, zeige eine Benachrichtigung
    if (!status.isAuthenticated && status.needsRenewal) {
      setNotification({
        show: true,
        message: status.message || 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
        isError: true
      });
    } 
    // Wenn die Sitzung bald abläuft, aber automatisch verlängert wird
    else if (status.isAuthenticated && status.message?.includes('bald ab')) {
      // Optional: Zeige eine Info-Benachrichtigung (könnte für Benutzer störend sein)
      // setNotification({
      //   show: true,
      //   message: status.message,
      //   isError: false
      // });
    }
    // Sonst verstecke die Benachrichtigung, wenn sie angezeigt wird
    else if (notification.show) {
      setNotification({ ...notification, show: false });
    }
  };

  const handleRelogin = () => {
    // Zum Login weiterleiten und aktuelle URL als Rückkehr-URL speichern
    navigate('/login', { state: { returnPath: window.location.pathname } });
  };

  const handleClose = () => {
    setNotification({ ...notification, show: false });
  };

  if (!notification.show) {
    return null;
  }

  return (
    <div className={`fixed bottom-4 right-4 p-4 rounded-lg shadow-lg max-w-sm z-50 ${
      notification.isError ? 'bg-red-50 border border-red-200' : 'bg-blue-50 border border-blue-200'
    }`}>
      <div className="flex justify-between">
        <p className={`text-sm ${notification.isError ? 'text-red-800' : 'text-blue-800'}`}>
          {notification.message}
        </p>
        <button
          onClick={handleClose}
          className="ml-4 text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>
      </div>
      
      {notification.isError && (
        <button
          onClick={handleRelogin}
          className="mt-2 px-4 py-1 bg-green-600 text-white text-sm rounded hover:bg-green-700"
        >
          Jetzt anmelden
        </button>
      )}
    </div>
  );
};

export default AuthNotification;